import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  isClosed: {
    display: 'none',
  },
  isOpen: {
    borderBottom: `${pxToRem(1)} solid ${theme.palette.neutralQuaternary}`,
  },
  iconColumn: {
    height: pxToRem(20),
    width: pxToRem(20),
    textAlign: 'center',
    fontSize: '1rem',
  },
  iconColumnHeader: {
    selectors: {
      '& .ms-DetailsHeader-cellName': {
        height: pxToRem(20),
        width: pxToRem(20),
        textAlign: 'center',
        fontSize: '1rem',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
      },
    },
  },
  headerIcon: {
    maxHeight: pxToRem(16),
    maxWidth: pxToRem(16),
    fontSize: '1rem',
    verticalAlign: 'middle',
  },
  viewButton: {
    marginLeft: pxToRem(40),
    fontSize: pxToRem(14),
  },
  bundleInfo: {
    paddingTop: pxToRem(24),
    paddingBottom: pxToRem(24),
    width: '99%',
    selectors: {
      '& .ms-DetailsList': {
        overflow: 'hidden !important',
      },
    },
    '>span': {
      paddingBottom: 7,
    },
  },
  meta: {
    paddingBottom: 20,
  },
  focusableGrid: {
    selectors: {
      ':focus': {
        outline: `thin solid ${theme.palette.black}`,
      },
    },
  },
});
